import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, EffectCoverflow } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-coverflow';
import 'tailwindcss/tailwind.css';
import img1 from '../assets/carousel/1.jpg';
import img2 from '../assets/carousel/2.jpg';
import img3 from '../assets/carousel/3.jpg';
import img4 from '../assets/carousel/4.jpg';
import img5 from '../assets/carousel/5.jpg';
import img6 from '../assets/carousel/6.jpeg';
import img7 from '../assets/carousel/7.jpeg';
import img8 from '../assets/carousel/8.jpeg';
import img9 from '../assets/carousel/9.png';
import img10 from '../assets/carousel/10.png';
import img11 from '../assets/carousel/11.jpeg';
import ambeMaa from '../assets/carousel/ambe_maa.jpg';
import dattatreya from '../assets/carousel/dattatreya.jpg';
import ganpatiBappa from '../assets/carousel/ganpati_bappa.jpg';
import ganpatiBhagwaan from '../assets/carousel/ganpati_bhagwaan.jpg';
import gayatriMaa from '../assets/carousel/gayatri_maa.jpg';
import hanumanBhagwaan from '../assets/carousel/hanuman_bhagwaan.jpg';
import jalaramBappa from '../assets/carousel/jalaram_bappa.jpg';
import krishnaBhagwaan from '../assets/carousel/krishna_bhagwaan.jpg';
import kshetraPal from '../assets/carousel/kshetra_pal.jpg';
import mahalaxmiMaa from '../assets/carousel/mahalaxmi_maa.jpg';
import navdurgaMata from '../assets/carousel/navdurga_mata.jpg';
import ramBhagwaan2 from '../assets/carousel/ram_bhagwaan_2.jpg';
import saiBaba from '../assets/carousel/sai_baba.jpg';
import saraswatiMata from '../assets/carousel/saraswati_mata.jpg';
import satyanarayanBhagwaan from '../assets/carousel/satyanarayan_bhagwaan.jpg';
import shivBhagwaan from '../assets/carousel/shiv_bhagwaan.jpg';
import vishwakarmaBhagwaan from '../assets/carousel/vishwakarma_bhagwaan.jpg';
import shri_hanuman_ji from '../assets/carousel/shri_hanuman_ji.jpg';

const Carousel = () => {
  const slides = [
    [img1, 'Shree Hanuman Ji'],
    [shri_hanuman_ji, 'Shree Hanuman Ji'],
    [hanumanBhagwaan, 'Shree Hanuman Ji'],
    [ramBhagwaan2, 'Shree Ram Parivaar'],
    [img7, 'Shree Ganesh Ji'],
    [img6, 'Shree Shiv Ji'],
    [ambeMaa, 'shree Ambe Maa'],
    [img9, 'shree Ambe Maa'],
    [navdurgaMata, 'shree Navdurga Maa'],
    [krishnaBhagwaan, 'Shree Radhe Krishna'],
    [img8, 'Shree Radhe Krishna'],
    [mahalaxmiMaa, 'Shree Mahalaxmi Maa'],
    [saraswatiMata, 'Shree Saraswati Maa'],
    [gayatriMaa, 'Shree Gayatri Maa'],
    [dattatreya, 'Shree Dattatreya Ji'],
    [satyanarayanBhagwaan, 'Shree Tirupati Balaji'],
    [vishwakarmaBhagwaan, 'Shree Vishwakarma Ji'],
    [saiBaba, 'Shree Sai Baba'],
    [kshetraPal, 'Shree Kshetra Pal Dada'],
    [jalaramBappa, 'Shree Jalaram Bappa'],
    [img2, 'Shree Hanuman Ji'],
    [img3, 'Shree Hanuman Ji'],
    [img4, 'Shree Hanuman Ji'],
    [shivBhagwaan, 'Shree Shiv Ji'],
    [img11, 'Shree Ram Parivaar'],
  ];

  return (
    <div className="w-full flex items-center justify-center">
      <div className="container">
        <Swiper
          effect="coverflow"
          grabCursor
          centeredSlides
          loop
          slidesPerView="auto"
          spaceBetween={40}
          coverflowEffect={{
            rotate: 0,
            stretch: 0,
            depth: 100,
            modifier: 2.5,
          }}
          navigation={{
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          }}
          modules={[Navigation, Pagination, EffectCoverflow]}
          className="tranding-slider"
        >
          {slides.map((slide, index) => (
            // <SwiperSlide
            //   key={index}
            //   className="w-[300px] h-[400px] relative rounded-xl overflow-hidden shadow-lg flex flex-col items-center"
            // >
            //   <img
            //     src={slide}
            //     alt={`slide-${index}`}
            //     className="w-full h-full object-cover"
            //   />
            //   <p>Label {index}</p>
            // </SwiperSlide>
            <SwiperSlide
              key={index}
              className="w-[300px] h-auto relative rounded-xl overflow-hidden shadow-lg flex flex-col items-center"
            >
              <div className="w-full h-[400px]">
                <img
                  src={slide[0]}
                  alt={`slide-${index}`}
                  className="w-full h-full object-cover"
                />
              </div>
              <p className="mt-2 text-center text-sm font-extrabold text-[#800000]">
                {`${slide[1]}`} {/* Replace with dynamic captions if needed */}
              </p>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};

export default Carousel;
